import {SubscriptionDetailsState} from "./SubscriptionDetailsState";
import {getTime} from "html-evaluate-utils/DateFormat";
import {PluginState} from "./PluginState";
import {CfgState} from "./CfgState";
import {LinkedInAccState} from "./LinkedInAccState";
import {AuthState} from "./AuthState";
import {ClickerUserState} from "./ClickerUserState";
import {PaymentInfoState} from "./PaymentInfoState";
import {onAuthStateChanged, onIdTokenChanged} from 'firebase/auth';
import {auth} from "../utils/firebase";
import {lc_subscription_details} from "clicker-common/src/staticData/lc_subscription_details";
import {lc_cfg} from "clicker-common/src/staticData/lc_cfg";
import {lc_linkedInAcc} from "clicker-common/src/staticData/lc_linkedInAcc";
import {lc_user} from "clicker-common/src/staticData/lc_user";
import {RuleState} from "./RuleState";
import {ActorState} from "./ActorState";
import {setAuthHeader} from "../services/apiClient";
import {SystemCfgState} from "./SystemCfgState";
import {WitAuditState} from "./WitAuditState";
import {WitConfigState} from "./WitConfigState";
import {WitTrainingQueueState} from "./WitTrainingQueueState";
import {ActionStatsState} from "./ActionStatsState";
import {NameConfigState} from "./NameConfigState";

export class RootState {
    prefix = "lc_";
    
    constructor() {
        console.log(getTime() + " RootState.init()");
        this.authState = new AuthState(this);
        this.subscriptionDetailsState = new SubscriptionDetailsState(this);
        this.pluginState = new PluginState(this);
        this.cfgState = new CfgState(this);
        this.linkedInAccState = new LinkedInAccState(this);
        this.clickerUserState = new ClickerUserState(this);
        this.paymentInfoStore = new PaymentInfoState(this);
        this.ruleState = new RuleState(this);
        this.actorState = new ActorState(this);
        this.systemCfgState = new SystemCfgState(this);
        this.witAuditState = new WitAuditState(this);
        this.witConfigState = new WitConfigState(this);
        this.witTrainingQueueState = new WitTrainingQueueState(this);
        this.actionStatsState = new ActionStatsState(this);
        this.nameConfigState = new NameConfigState(this);

        this.subscriptionDetailsState.setup(this.authState, "RootState.constructor()");
        this.cfgState.setup(this.authState, "RootState.constructor()");
        this.linkedInAccState.setup(this.authState, "RootState.constructor()");
        this.clickerUserState.setup(this.authState, "RootState.constructor()");
        this.paymentInfoStore.setup(this.authState, this.subscriptionDetailsState, "RootState.constructor()");
        this.ruleState.setup(this, this.cfgState);
        this.actorState.setup(null, this.cfgState, "RootState.constructor()");

        this.setupEventListener();
    }

    setupEventListener(){
        window.addEventListener('message', (event) => {
            if (event.data.type === 'lc_get_is_clicker_installed_response') {
                this.pluginState.setPluginInstalled(true, " RootState message event");
            }
        });
        onIdTokenChanged(auth, async (currentUser) => {
            if (currentUser !== null && currentUser.uid !== null && !currentUser.isAnonymous) {
                const tokenResult = await currentUser.getIdTokenResult(false);
                const token = tokenResult.token;
                this.authState.serverToken = token;
                this.authState.setAdminClaims(tokenResult.claims);
                setAuthHeader(token);
                this.pluginState.postAuthTokenToExtension(token);
            } else {
                this.authState.setAdminClaims({});
                setAuthHeader(null);
                this.pluginState.clearAuthTokenInExtension();
            }
        });
        onAuthStateChanged(auth, async (currentUser) => {
            if (currentUser !== null && currentUser.uid !== null && !currentUser.isAnonymous) {
                console.log(getTime() + " RootState.onAuthChange() user login");
                this.authState.user = currentUser;
                const tokenResult = await currentUser.getIdTokenResult(true);
                const token = tokenResult.token;
                this.authState.serverToken = token;
                this.authState.setAdminClaims(tokenResult.claims);
                setAuthHeader(token);
                this.cfgState.dataLoaded = false;
                this.witAuditState.reset();
                this.cfgState.loadFromServiceByUserId(currentUser.uid, " RootState.onAuthChange() user login");
                if (this.authState.isSystemAdmin()) {
                    this.systemCfgState.dataLoaded = false;
                    this.systemCfgState.loadPublicSystemCfg("RootState.onAuthChange() user login");
                }
            } else {
                console.log(getTime() + " RootState.onAuthChange() user logout");
                this.authState.setAdminClaims({});
                setAuthHeader(null);
                this.pluginState.clearAuthTokenInExtension();
                this.cfgState.dataLoaded = false;
                this.systemCfgState.reset();
                this.witAuditState.reset();
                this.actionStatsState.reset();
                await this.clearDataOnLogOut();
            }
        });
    }

    async clearDataOnLogOut() {
        this.subscriptionDetailsState.setSubscriptionDetails(lc_subscription_details);
        this.cfgState.setRootCfg(lc_cfg);
        this.linkedInAccState.setLinkedInAcc(lc_linkedInAcc);
        this.authState.serverToken = null;
        this.authState.user = lc_user;
    }
}
